import { Component, Input, OnInit } from '@angular/core';

import { TabTemplate } from '../../models';
import { FormService, ModalService } from '../../services';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrl: './tab.component.scss',
})
export class TabComponent implements OnInit {
  @Input() model: any;
  @Input() templates: TabTemplate[] = [];
  @Input() showAll = false;
  @Input() fullWidth = false;
  @Input() hasModel = true;
  @Input() highlightText = false;

  isModal: boolean;

  constructor(
    private formService: FormService,
    private modalService: ModalService,
  ) {}

  ngOnInit() {
    this.isModal = this.modalService.anyModalsOpen;
  }

  get templatesToShow(): TabTemplate[] {
    return this.hasModel && this.formService.isNewModel(this.model) && !this.showAll
      ? this.templates.slice(0, 1)
      : this.templates;
  }
}
